import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useMe } from '@/hooks/use-me';

// Cold start de Railway: si /api/auth/me tarda, avisamos después de 5s en
// vez de dejar el spinner mudo (mismo umbral que RISIT).
const HINT_DELAY_MS = 5_000;

function LoadingScreen() {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setShowHint(true), HINT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-surface-page text-muted-foreground">
      <Loader2 className="size-6 animate-spin" aria-hidden="true" />
      <p className="text-sm">Cargando…</p>
      {showHint && (
        <p className="max-w-xs text-center text-xs text-muted-foreground">
          El servidor está tardando más de lo habitual. Probablemente esté despertando.
        </p>
      )}
    </div>
  );
}

// Gate de sesión: si todavía no sabemos si hay sesión, muestra loading; si
// no hay sesión, redirige a /login guardando el origen. La sesión misma
// viene del cache de react-query (['auth','me']) vía useMe(), no de un
// context propio — el mismo cache lo consume UserMenu en el Sidebar.
export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: user, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
